import React from 'react';
import { Link } from 'react-router-dom';
import FacebookIcon from 'mdi-react/FacebookIcon';
import GooglePlusIcon from 'mdi-react/GooglePlusIcon';
import backGroundImage from '../../../images/login_bckground_img.png';
import LocationSelectionForm from './components/LocationSelectionForm';
import './login.css';
import logo from '../../../images/loginAssest.png'

const LocationSelection = () => (
  <div className="account login_main_left_container" style={{backgroundColor: '#fff'
}}>
    <div className="login_left_container" style={{width: '53%', float:'left' ,backgroundColor: '#fef1cc', flexDirection: 'column'}}>
      <div style={{paddingLeft: 40, paddingTop: 60}}>
         <img
                    src={require("../../../images/login_text1.png")}
                    style={{width: '60%'}}
                  ></img>
      </div>

      <div style={{flexDirection: 'column'}}>

      <img
                    src={require("../../../images/Illustration.svg")}
                    style={{width: '100%'}}
                  ></img>
    <div style={{textAlign: 'right', paddingRight: 20, marginTop: -80}}>
<img
                    src={require("../../../images/Crafted_with.svg")}
                    style={{width: '9%'}}
                  ></img>
                  <img
                    src={require("../../../images/Vector.svg")}
                    style={{width: '2%', marginRight: 3, marginLeft: 3}}
                  ></img>

                   <img
                    src={require("../../../images/from.svg")}
                    style={{width: '4%'}}
                  ></img>
                  </div>
      <div style={{textAlign: 'right', paddingRight: 20, marginTop: 8}}>
<img
                    src={require("../../../images/Lynk_Logo.svg")}
                    style={{width: '16%'}}
                  ></img>
          </div>


      </div>

    </div>
    <div className="account__wrapper" style={{width: '60%', float: 'left', margin: 'inherit', textAlign: 'center', justifyContent: 'center'}}>
      <div className="account__card" id="login_right_card">
        <div className="account__head" style={{borderLeftWidth: 0, flexDirection: 'row'}}>
          <img style={{width: '23%'}} src={require("../../../images/Jarvis.svg")} />
          <img style={{width: '5%'}} src={require("../../../images/Jarvis_logo.svg")} />
          
        </div>

        <LocationSelectionForm onSubmit />
      </div>
    </div>
    <div style = {{width: '10%', float: 'left'}}>

    </div>
  </div>
);

export default LocationSelection;
 